import { HLS_KR, HLS, SS, WVC } from '../../utils/playerConstants';
import deviceInfo from '../all/deviceInfo';

const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;
// WVC
multipleaudio.wvc = {};
multipleaudio.wvc.vod = false;
multipleaudio.wvc.live = false;
multipleaudio.wvc.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS, HLS, WVC];
supported_stream_types.live = [SS, HLS_KR, HLS];
supported_stream_types.timeshift = [SS];

export default {
  appKey: 'd23603e3a4c675a19358e4c397d00866', // TODO ESTO ES DE NAGRA
  appSubkey: 'samsung',
  // Request params
  device_category: 'tv',
  /* device_id:"nousar", */
  device_manufacturer: 'samsung',
  device_model: 'samsung',
  device_name: 'samsung',
  device_so: deviceInfo.os.description || 'orsay',
  device_type: 'tv',
  stream_type: 'smooth_streaming',
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  akamai_id: 'SamsungSTV',
  useEpgPostals: true,
  // akamai_mfwk: 'mfwktv2samsung-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwktv2samsung-api.clarovideo.net' : 'http://mfwktv2samsung-api.clarovideo.net'
};



// WEBPACK FOOTER //
// ./src/devices/samsung/config.js